
import BlogHeader from '../components/BlogHeader';
import Footer from '../../home/components/Footer';
import NewsletterSignup from '../components/NewsletterSignup';
import SoftwareList from './components/SoftwareList';
import ArticleHero from './components/ArticleHero';
import ArticleIntro from './components/ArticleIntro';
import ComparisonTable from './components/ComparisonTable';
import ArticleConclusion from './components/ArticleConclusion';
import { useEffect } from 'react';

export default function CloudAccountingSoftwarePage() {
  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Failed to scroll to top:', error);
    }
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Top 7 Cloud-Based Accounting Softwares for Small Business",
    "description":
      "Discover the best cloud-based accounting software options for small businesses. Compare features, pricing, and benefits of QuickBooks, Xero, FreshBooks, and more.",
    "author": { "@type": "Organization", "name": "El Paso QuickBooks Bookkeeping Services" },
    "publisher": { "@type": "Organization", "name": "El Paso QuickBooks Bookkeeping Services" },
    "datePublished": "2025-01-15",
    "dateModified": "2025-02-18",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://elpasoquickbooksbookkeeping.com/blog/top-cloud-accounting-softwares"
    },
    "keywords":
      "cloud accounting software, QuickBooks Online, Xero, FreshBooks, small business accounting, El Paso bookkeeping"
  };

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://elpasoquickbooksbookkeeping.com/" },
      { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://elpasoquickbooksbookkeeping.com/blog" },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Top Cloud Accounting Softwares",
        "item": "https://elpasoquickbooksbookkeeping.com/blog/top-cloud-accounting-softwares"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <BlogHeader />
      <ArticleHero />
      <main>
        <article className="max-w-4xl mx-auto px-6">
          <ArticleIntro />
          <SoftwareList />
          <ComparisonTable />
          <ArticleConclusion />
        </article>
      </main>
      <NewsletterSignup />
      <Footer />

      {/* Structured data scripts */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      ></script>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      ></script>
    </div>
  );
}
